import React from "react";
import {
    Button,
    Box,
    CircularProgress,
    Typography,
} from "@mui/material";
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import { RemoveIcon } from "../../../assets/images";
import { Modal } from "react-bootstrap";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ListAltIcon from "@mui/icons-material/ListAlt";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import SettingsIcon from "@mui/icons-material/Settings";
import CancelIcon from "@mui/icons-material/Cancel";
import TableViewRoundedIcon from '@mui/icons-material/TableViewRounded';
import DeviceDetails from "./DeviceDetails";

/**
 * Unified ONVIF manual onboard/update modal.
 * Works for both NVR/DVR and Camera tabs — the only difference is the `tableFor` prop
 * which is forwarded to <DeviceDetails> ("nvr/dvr" | "camera").
 * All payload-construction logic stays in the parent (NVRDiscover / CameraDiscover).
 */
const OnvifManualOnboardModal = ({
    showAdditionalModal,
    onCloseBtn,
    selectedRow,
    onvifIPAddress,
    setOnvifIPAddress,
    onVifIPAddressError,
    onvifPort,
    setOnvifPort,
    onVifPortError,
    onvifUserName,
    setOnvifUserName,
    onVifUserNameError,
    onvifPassword,
    setOnvifPassword,
    onVifPasswordError,
    onSubmitBtn,
    deviceInfoLoading,
    deviceInfo,
    deviceName,
    setDeviceName,
    interfaceSubTypeData,
    selectedBrand,
    setSelectedBrand,
    selectedTimeZone,
    setSelectedTimeZone,
    timezone,
    tcpPort,
    setTcpPort,
    interfaceUserName,
    setInterfaceUserName,
    interfacePassword,
    setInterfacePassword,
    isEditMode,
    selectedCustomer,
    setSelectedCustomer,
    selectedSite,
    setSelectedSite,
    setSiteSearch,
    customerOptions,
    siteOptions,
    devices,
    setDevices,
    onBoardDevice,
    tableFor,
    deviceTypeName,
    dbProfiles,
}) => {
    return (
        <Modal
            show={showAdditionalModal}
            onHide={() => onCloseBtn()}
            dialogClassName="DiscoverWidgetModelDiv"
            aria-labelledby="example-custom-modal-styling-title"
        >
            <>
                <Modal.Header>
                    <Modal.Title
                        id="example-custom-modal-styling-title"
                        title={`Connected to Camera ${deviceName || (selectedRow ? selectedRow.Name : "")} with IP ${onvifIPAddress || (selectedRow ? selectedRow.IP : "")} via Onvif`}
                    >
                        {deviceName || (selectedRow ? selectedRow.Name : "Please fill details to fetch data")} -{" "}
                        {/* {onvifIPAddress || (selectedRow ? selectedRow.IP : "")} */}
                        {isEditMode ? " (Edit Mode)" : " (View Mode)"}
                    </Modal.Title>
                    <img
                        src={RemoveIcon}
                        alt="Remove"
                        style={{ cursor: "pointer" }}
                        onClick={() => onCloseBtn()}
                    />
                </Modal.Header>
                
                <Modal.Body style={{ paddingBottom: "0px" }}>
                    <form style={{ width: "100%" }}>
                        {(selectedRow === null) &&
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div className="inputMainContainer w40dot75rem">
                                    <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">
                                            IP Address<span style={{ color: "red" }}> *</span>
                                        </label>
                                        <input
                                            className="inputType"
                                            placeholder="Enter IPAddress"
                                            value={onvifIPAddress}
                                            disabled={deviceInfo ? true : false}
                                            onChange={(e) => setOnvifIPAddress(e.target.value)}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}>
                                            <span> {onVifIPAddressError} </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="inputMainContainer w40dot75rem ml-4">
                                    <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">
                                            Port<span style={{ color: "red" }}> *</span>
                                        </label>
                                        <input
                                            className="inputType"
                                            placeholder="Enter Port*"
                                            value={onvifPort}
                                            disabled={deviceInfo ? true : false}
                                            onChange={(e) => setOnvifPort(e.target.value)}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}>
                                            <span> {onVifPortError} </span>
                                        </p>
                                    </div>
                                </div>
                                <div style={{ height: "35px", width: "230px", display: "inline-block" }}></div>
                            </div>
                        }
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottom: "1px solid #ccc",
                                paddingBottom: "15px",
                            }}
                        >
                            <div className="inputMainContainer w40dot75rem">
                                <div className="inputTypeLabelContainer">
                                    <label className="formFieldLabels">
                                        Onvif Username<span style={{ color: "red" }}> *</span>
                                    </label>
                                    <input
                                        className="inputType"
                                        placeholder="Enter Username*"
                                        value={onvifUserName}
                                        disabled={deviceInfo ? true : false}
                                        onChange={(e) => setOnvifUserName(e.target.value)}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}>
                                        <span> {onVifUserNameError} </span>
                                    </p>
                                </div>
                            </div>
                            <div className="inputMainContainer w40dot75rem ml-4">
                                <div className="inputTypeLabelContainer">
                                    <label className="formFieldLabels">
                                        Onvif Password<span style={{ color: "red" }}> *</span>
                                    </label>
                                    <input
                                        className="inputType"
                                        placeholder="Enter Password*"
                                        value={onvifPassword}
                                        disabled={deviceInfo ? true : false}
                                        onChange={(e) => setOnvifPassword(e.target.value)}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}>
                                        <span> {onVifPasswordError} </span>
                                    </p>
                                </div>
                            </div>
                            <Button
                                className="ml-4"
                                variant="contained"
                                color="primary"
                                size="medium"
                                style={{ height: "35px", width: "130px" }}
                                onClick={onSubmitBtn}
                                disabled={deviceInfoLoading ? true : false}
                            >
                                Submit
                            </Button>
                        </div>
                    </form>

                    <div
                        className="DiscoverFormAdditionForm border-top-0"
                        style={{ height: "520px", overflowY: "auto" }}
                    >
                        {deviceInfoLoading ? (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight="300px"
                            >
                                <CircularProgress />
                            </Box>
                        ) : !deviceInfo ? (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight="300px"
                            >
                                <Typography color="textSecondary">
                                    Please enter credentials and submit to fetch device information.
                                </Typography>
                            </Box>
                        ) : (
                            <div className="device-info-container">
                                {/* Device Overview */}
                                <div className="section">
                                    <div className="section-title">
                                        <ListAltIcon sx={{ color: "#455a64", mr: 1 }} />
                                        Device Overview
                                    </div>
                                    <div className="info-box">
                                        <div className="info-row">
                                            <span className="label">Device Name</span>
                                            <input
                                                type="text"
                                                className="value"
                                                value={deviceName}
                                                onChange={(e) => setDeviceName(e.target.value)}
                                                style={{
                                                    border: `${deviceName ? "1px solid #ccc" : "1px solid red"}`,
                                                    padding: '2px 4px',
                                                    borderRadius: '2px',
                                                    width: "auto",
                                                    maxWidth: "50%",
                                                    background: 'transparent',
                                                    textAlign: "right",
                                                }}
                                            />
                                        </div>
                                        <div className="info-row">
                                            <span className="label">System</span>
                                            <span className="value">CCTV</span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Brand</span>
                                            <select
                                                value={selectedBrand}
                                                // disabled={isEditMode}
                                                onChange={(e) => setSelectedBrand(e.target.value)}
                                                style={{
                                                    width: "18%",
                                                    padding: "8px 10px",
                                                    //border: "1px solid #ccc",
                                                    border: `${selectedBrand ? "1px solid #ccc" : "1px solid red"}`,
                                                    borderRadius: "4px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {Array.isArray(interfaceSubTypeData) &&
                                                    interfaceSubTypeData.map((item) => (
                                                        <option
                                                            key={item.InterfacesubtypeId}
                                                            value={item.InterfacesubtypeId}
                                                        >
                                                            {item.Interfacesubtypename}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Device Type</span>
                                            <span className="value">
                                                {deviceTypeName || selectedRow?.DeviceType || "Not Available"}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Firmware</span>
                                            <span className="value">
                                                {deviceInfo?.Firmware || "Not Available"}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Serial Number</span>
                                            <span className="value">
                                                {deviceInfo?.SerialNumber || "Not Available"}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Timezone</span>
                                            <select
                                                value={selectedTimeZone}
                                                onChange={(e) => setSelectedTimeZone(e.target.value)}
                                                style={{
                                                    width: "18%",
                                                    padding: "8px 10px",
                                                    border: `${selectedTimeZone ? "1px solid #0b70d1" : "1px solid red"}`,
                                                    borderRadius: "4px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {Array.isArray(timezone) &&
                                                    timezone.map((item) => (
                                                        <option
                                                            key={item.TimeZoneId}
                                                            value={item.TimeZoneId}
                                                        >
                                                            {item.Fullname} - {item.Abbreviation}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Network Details */}
                                <div className="section">
                                    <div className="section-title">
                                        <NetworkCheckIcon sx={{ color: "#0288d1", mr: 1 }} />
                                        Network Details
                                    </div>
                                    <div className="info-box">
                                        <div className="info-row">
                                            <span className="label">IP Address</span>
                                            <span className="value" style={{ textAlign: "right" }}>
                                                {selectedRow?.IP || onvifIPAddress || "Not Available"}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">HTTP Port</span>
                                            <span className="value">
                                                {deviceInfo?.NetworkInfo?.HTTPPort || "Not Available"}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">RTSP Port</span>
                                            <span className="value">
                                                {deviceInfo?.NetworkInfo?.RTSPPort || "Not Available"}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">TCP Port</span>
                                            <input
                                                type="text"
                                                className="value"
                                                value={tcpPort}
                                                onChange={(e) => setTcpPort(e.target.value)}
                                                style={{
                                                    border: `${tcpPort ? "1px solid #0b70d1" : "1px solid red"}`,
                                                    padding: "2px 4px",
                                                    borderRadius: "2px",
                                                    width: "auto",
                                                    maxWidth: "5%",
                                                    background: "transparent",
                                                    textAlign: "right",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Capabilities */}
                                <div className="section">
                                    <div className="section-title">
                                        <SettingsIcon sx={{ color: "#f57c00", mr: 1 }} />
                                        Capabilities
                                    </div>
                                    <div className="info-box">
                                        <div className="info-row">
                                            <span className="label">Profiles</span>
                                            <span className="value">
                                                {(() => {
                                                    const profiles = deviceInfo?.Profiles || dbProfiles || selectedRow?.Profiles;
                                                    if (Array.isArray(profiles) && profiles.length > 0)
                                                        return profiles.map((p) => `[ ${p} ]`).join(" ");
                                                    if (typeof profiles === "string" && profiles)
                                                        return profiles;
                                                    return "Not Available";
                                                })()}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">PTZ</span>
                                            <span className="value">
                                                {deviceInfo.Capabilities.PTZ === null || deviceInfo.Capabilities.PTZ === undefined || deviceInfo.Capabilities.PTZ === '' ? (
                                                    <>Not Available</>
                                                ) : deviceInfo.Capabilities.PTZ ? (
                                                    <><CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />Supported</>
                                                ) : (
                                                    <><CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />Not Supported</>
                                                )}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Events</span>
                                            <span className="value">
                                                {deviceInfo.Capabilities.Events === null || deviceInfo.Capabilities.Events === undefined || deviceInfo.Capabilities.Events === '' ? (
                                                    <>Not Available</>
                                                ) : deviceInfo.Capabilities.Events ? (
                                                    <><CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />Supported</>
                                                ) : (
                                                    <><CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />Not Supported</>
                                                )}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Two Way Audio</span>
                                            <span className="value">
                                                {deviceInfo.Capabilities.Audio ? (
                                                    <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                                ) : (
                                                    <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                )}
                                                {deviceInfo.Capabilities.Audio ? "Supported" : "Not Supported"}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Hooter</span>
                                            <span className="value">
                                                {deviceInfo.Capabilities.Relay ? (
                                                    <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                                ) : (
                                                    <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                )}
                                                {deviceInfo.Capabilities.Relay ? "Supported" : "Not Supported"}
                                            </span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Video Analytics</span>
                                            <span className="value">
                                                {deviceInfo.Capabilities.VideoAnalytics === null || deviceInfo.Capabilities.VideoAnalytics === undefined || deviceInfo.Capabilities.VideoAnalytics === '' ? (
                                                    <>Not Available</>
                                                ) : deviceInfo.Capabilities.VideoAnalytics ? (
                                                    <><CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />Supported</>
                                                ) : (
                                                    <><CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />Not Supported</>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Communication Settings */}
                                <div className="section">
                                    <div className="section-title">
                                        <ConnectWithoutContactIcon sx={{ color: "#d11d62", mr: 1 }} />
                                        Communication Settings
                                    </div>
                                    <div className="info-box">
                                        <div className="info-row">
                                            <span className="label">Interface Username</span>
                                            <input
                                                type="text"
                                                className="value"
                                                value={interfaceUserName}
                                                onChange={(e) => setInterfaceUserName(e.target.value)}
                                                style={{
                                                    border: `1px solid #0b70d1`,
                                                    padding: "2px 4px",
                                                    borderRadius: "2px",
                                                    width: "auto",
                                                    maxWidth: "50%",
                                                    background: "transparent",
                                                    textAlign: "right",
                                                }}
                                            />
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Interface Password</span>
                                            <input
                                                type="text"
                                                className="value"
                                                value={interfacePassword}
                                                onChange={(e) => setInterfacePassword(e.target.value)}
                                                style={{
                                                    border: `1px solid #0b70d1`,
                                                    padding: "2px 4px",
                                                    borderRadius: "2px",
                                                    width: "auto",
                                                    maxWidth: "50%",
                                                    background: "transparent",
                                                    textAlign: "right",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Devices Table */}
                                <div className="section">
                                    <div className="section-title">
                                        <TableViewRoundedIcon sx={{ color: "#158533", mr: 1 }} />
                                        Devices Details
                                    </div>
                                    {console.log('Devices in Modal', { devices })}
                                    <div className="info-box" style={{ padding: 0 }}>
                                        <DeviceDetails devices={devices} setDevices={setDevices} tableFor={tableFor} />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "15px",
                        padding: "15px",
                        width: "100%",
                    }}>
                        <div style={{ display: "flex", gap: "15px", flex: 1 }}>
                            {/* Customer Dropdown */}
                            <div style={{ flex: 1 }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                }}>
                                    Customer <span style={{ color: "red" }}> *</span>
                                </label>
                                <select
                                    value={selectedCustomer}
                                    disabled={!deviceInfo || isEditMode}
                                    onChange={(e) => {
                                        setSelectedCustomer(e.target.value);
                                        setSelectedSite("");
                                        setSiteSearch("");
                                    }}
                                    style={{
                                        width: "100%",
                                        padding: "8px 10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        backgroundColor: !deviceInfo ? "#f5f5f5" : "white",
                                    }}
                                >
                                    <option value="">-- Select Customer --</option>
                                    {customerOptions.map((customer) => (
                                        <option key={customer.id} value={customer.id}>
                                            {customer.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Site Dropdown */}
                            <div style={{ flex: 1 }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                }}>
                                    Site <span style={{ color: "red" }}> *</span>
                                </label>
                                <select
                                    value={selectedSite}
                                    onChange={(e) => setSelectedSite(e.target.value)}
                                    disabled={!selectedCustomer || siteOptions.length === 0 || isEditMode}
                                    style={{
                                        width: "100%",
                                        padding: "8px 10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        backgroundColor: !selectedCustomer || siteOptions.length === 0 ? "#f5f5f5" : "white",
                                    }}
                                >
                                    <option value="">{siteOptions.length === 0 && selectedCustomer ? "-- No site found --" : "-- Select Site --"}</option>
                                    {siteOptions.map((site) => (
                                        <option key={site.id} value={site.id}>
                                            {site.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Device Onboard / Update Button */}
                        <button
                            className="DataAccessEdit mt-3"
                            onClick={() => onBoardDevice()}
                            disabled={!selectedCustomer || !selectedSite || !deviceInfo}
                            style={{
                                width: "180px",
                                height: "35px",
                                alignSelf: "flex-end",
                            }}
                        >
                            <span className="ViewUpdate">{isEditMode ? 'Update Device' : 'Onboard Device'}</span>
                        </button>
                    </div>
                </Modal.Footer>
            </>
        </Modal>
    );
};

export default OnvifManualOnboardModal;
